<div class="create-job-container">
    <!-- Breadcrumb -->
    <div class="breadcrumb">
        <a [routerLink]="'/dashboard'">Home</a>
        <span class="separator">›</span>
        <a [routerLink]="'/ota-dashboard'">OTA</a>
        <span class="separator">›</span>
        <span class="current">Create OTA JOB</span>
    </div>

    <!-- Main Content -->
    <div class="main-content">
        <!-- Step Indicator -->
        <div class="step-indicator">
            <div *ngFor="let step of getVisibleSteps()" class="step" [class.completed]="step < currentStep"
                [class.active]="step === currentStep" [class.pending]="step > currentStep">
                <div class="step-number">{{ getDisplayStepNumber(step) }}</div>
                <div class="step-content-indicator">
                    <div class="step-title" [ngSwitch]="step">
                        <span *ngSwitchCase="1">Basic Details</span>
                        <span *ngSwitchCase="2">Wi-Fi Board Firmware</span>
                        <span *ngSwitchCase="3">Main Board Firmware</span>
                        <span *ngSwitchCase="4">Configurations</span>
                        <span *ngSwitchCase="5">Review and Finish</span>
                    </div>
                    <div class="step-description" [ngSwitch]="step">
                        <span *ngSwitchCase="1">Enter information</span>
                        <span *ngSwitchCase="2">Enter information</span>
                        <span *ngSwitchCase="3">Optional</span>
                        <span *ngSwitchCase="4">Optional</span>
                        <span *ngSwitchCase="5">Finalise information</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Success Message (Shown after job creation) -->
        <div *ngIf="jobCreated" class="success-message-container">
            <h3>Success</h3>
            <div class="success-message-content">
                <div class="success-icon">✓</div>
                <p class="success-title">Your OTA Job has been successfully created</p>
                <p class="success-subtitle">To View your recently created OTA Job please click <a href="#"
                        class="success-link" (click)="goBackToDashboard(); $event.preventDefault()">here</a></p>
            </div>
            <button class="btn btn-create-job" (click)="createAnotherJob()">
                <span class="plus-icon">+</span> Create a Job
            </button>
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage && !jobCreated" class="error-message">
            {{ errorMessage }}
        </div>

        <!-- Form Screen -->
        <ng-container *ngIf="!jobCreated">


            <!-- Form Container -->
            <div class="form-wrapper">
                <!-- Step 1: Basic Details -->
                <div *ngIf="currentStep === 1" class="form-container">
                    <!-- Left Column: Form -->
                    <div class="form-column">
                        <div class="form-section">
                            <h3>Job Details</h3>

                            <div class="form-group">
                                <label>Job Name<span class="required">*</span></label>
                                <input type="text" class="form-control" placeholder="Type here"
                                    [(ngModel)]="jobData.job_name" (ngModelChange)="sanitizeJobName($event)"
                                    (keypress)="allowOnlyAlphanumeric($event)"/>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>Actual Model<span class="required">*</span></label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-select [(ngModel)]="jobData.actual_model"
                                            panelClass="mat-mdc-select-panel-custom" 
                                            (ngModelChange)="onActualModelChange($event)"
                                            [disabled]="isSignedMetadataLoading"
                                            name="actualModel">
                                            <mat-option value="">Select</mat-option>
                                            <mat-option *ngFor="let model of actualModels" [value]="model.value">
                                                {{ model.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <small *ngIf="isSignedMetadataLoading">Loading signed metadata...</small>
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Model<span class="required">*</span></label>
                                <input type="text" class="form-control" placeholder="Type here"
                                    [(ngModel)]="jobData.model"/>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>In Progress Timeout (Min)<span class="required">*</span></label>
                                    <input type="number" class="form-control" placeholder="Type here"
                                        [(ngModel)]="jobData.inprogress_timeout_in_minutes" min="1" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Right Column: Preview -->
                    <div class="preview-column">
                        <div class="preview-header">Preview</div>
                        <div class="preview-section">

                            <div class="preview-item">
                                <span class="preview-label">Job Name</span>
                                <span class="preview-value">{{ jobData.job_name || '' }}</span>
                            </div>

                            <div class="preview-item">
                                <span class="preview-label">Actual Model</span>
                                <span class="preview-value">{{ getDropdownLabel(jobData.actual_model, actualModels) || '' }}</span>
                            </div>

                            <div class="preview-item">
                                <span class="preview-label">Model</span>
                                <span class="preview-value">{{ getDropdownLabel(jobData.model, models) || '' }}</span>
                            </div>

                            <div class="preview-item">
                                <span class="preview-label">In Progress Timeout (Min)</span>
                                <span class="preview-value">{{ jobData.inprogress_timeout_in_minutes }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 2: Wi-Fi Board Firmware -->
                <div *ngIf="currentStep === 2" class="form-container">
                    <!-- Left Column: Form -->
                    <div class="form-column">
                        <div class="form-section">
                            <h3>Wi-Fi Board Firmware Details</h3>
                            <div class="form-row">

                                <div class="form-group">
                                    <label>Firmware Version</label>
                                    <input type="text" class="form-control" placeholder="e.g., 1.0.0"
                                        [(ngModel)]="jobData.wifi_firmware_version" />
                                    <mat-error *ngIf="isWifiVersionInvalid()">
                                        Version must follow semantic versioning (e.g. 1.2.3)</mat-error>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>Firmware Path on Device*</label>
                                    <input type="text" class="form-control" placeholder=""
                                        [(ngModel)]="jobData.wifi_firmware_path_on_device" />
                                </div>

                                <div class="form-group">
                                    <label>Priority</label>
                                    <input type="number" class="form-control" placeholder=""
                                        [(ngModel)]="jobData.wifi_firmware_priority" min="0" />
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Description*</label>
                                <textarea matInput [(ngModel)]="jobData.wifi_firmware_description"
                                    placeholder="Type here" class="description-textarea" required></textarea>
                            </div>
                        </div>
                    </div>

                    <!-- Right Column: Preview -->
                    <div class="preview-column">
                        <div class="preview-header">Preview</div>
                        <div class="preview-section">

                            <div class="preview-item">
                                <span class="preview-label">Firmware Version</span>
                                <span class="preview-value">{{ jobData.wifi_firmware_version || '' }}</span>
                            </div>
                            <div class="preview-item">
                                <span class="preview-label">Firmware Path on Device</span>
                                <span class="preview-value">{{ jobData.wifi_firmware_path_on_device || ''
                                    }}</span>
                            </div>
                            <div class="preview-item">
                                <span class="preview-label">Priority</span>
                                <span class="preview-value">{{ jobData.wifi_firmware_priority || '' }}</span>
                            </div>
                            <div class="preview-item">
                                <span class="preview-label">Description</span>
                                <span class="preview-value">{{ jobData.wifi_firmware_description || '' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 3: Main Board Firmware -->
                <div *ngIf="currentStep === 3 && !isMainBoardFirmwareDisabled" class="form-container">
                    <!-- Left Column: Form -->
                    <div class="form-column">
                        <div class="form-section">
                            <p class="form-description">Optional section: You can skip this. If you fill any field, all fields are required.</p>
                            <h3>Main Board Firmware Details</h3>
                            <div class="form-row">

                                <div class="form-group">
                                    <label>Firmware Version</label>
                                    <input type="text" class="form-control" placeholder="e.g., 1.0.0"
                                        [(ngModel)]="jobData.main_firmware_version"
                                        [disabled]="isMainBoardFirmwareDisabled" />
                                    <mat-error *ngIf="isMainboardVersionInvalid()">
                                        Version must follow semantic versioning (e.g. 1.2.3)</mat-error>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>Firmware Path on Device*</label>
                                    <input type="text" class="form-control" placeholder=""
                                        [(ngModel)]="jobData.main_firmware_path_on_device"
                                        [disabled]="isMainBoardFirmwareDisabled" />
                                </div>

                                <div class="form-group">
                                    <label>Priority</label>
                                    <input type="number" class="form-control" placeholder=""
                                        [(ngModel)]="jobData.main_firmware_priority" min="0"
                                        [disabled]="isMainBoardFirmwareDisabled" />
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Description*</label>
                                <textarea matInput [(ngModel)]="jobData.main_firmware_description"
                                    placeholder="Type here" class="description-textarea" required
                                    [disabled]="isMainBoardFirmwareDisabled"></textarea>
                            </div>

                        </div>
                    </div>

                    <!-- Right Column: Preview -->
                    <div class="preview-column">
                        <div class="preview-header">Preview</div>
                        <div class="preview-section">

                            <div class="preview-item">
                                <span class="preview-label">Firmware Version</span>
                                <span class="preview-value">{{ jobData.main_firmware_version || '' }}</span>
                            </div>
                            <div class="preview-item">
                                <span class="preview-label">Firmware Path on Device</span>
                                <span class="preview-value">{{ jobData.main_firmware_path_on_device || ''
                                    }}</span>
                            </div>
                            <div class="preview-item">
                                <span class="preview-label">Priority</span>
                                <span class="preview-value">{{ jobData.main_firmware_priority || '' }}</span>
                            </div>
                            <div class="preview-item">
                                <span class="preview-label">Description</span>
                                <span class="preview-value">{{ jobData.main_firmware_description || '' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 4: Configurations -->
                <div *ngIf="currentStep === 4" class="form-container">
                    <!-- Left Column: Form -->
                    <div class="form-column">
                        <div class="form-section">
                            <h3>Job Executions Rollout Configuration</h3>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>Base Rate Per Minute</label>
                                    <input type="number" class="form-control"
                                        [(ngModel)]="jobData.job_executions_rollout_config!.baseRatePerMinute"
                                        placeholder="50" />
                                </div>

                                <div class="form-group">
                                    <label>Increment Factor</label>
                                    <input type="number" class="form-control"
                                        [(ngModel)]="jobData.job_executions_rollout_config!.incrementFactor"
                                        placeholder="2" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>Number of Succeeded Things</label>
                                    <input type="number" class="form-control"
                                        [(ngModel)]="jobData.job_executions_rollout_config!.numberOfSucceededThings"
                                        placeholder="1000" />
                                </div>

                                <div class="form-group">
                                    <label>Maximum Per Minute</label>
                                    <input type="number" class="form-control"
                                        [(ngModel)]="jobData.job_executions_rollout_config!.maximumPerMinute"
                                        placeholder="1000" />
                                </div>
                            </div>

                            <h3>Abort Configuration 1</h3>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>Action</label>
                                    <input type="text" class="form-control" placeholder="CANCEL"
                                        [(ngModel)]="jobData.abort_config!.configurations[0].action" />
                                </div>

                                <div class="form-group">
                                    <label>Failure Type</label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-select
                                            [(ngModel)]="jobData.abort_config!.configurations[0].failureType"
                                            (ngModelChange)="onFailureTypeChange(0)"
                                            panelClass="mat-mdc-select-panel-custom"
                                            name="abortFailureType1">
                                            <mat-option *ngFor="let option of getFailureTypeOptions(0)" [value]="option.value">
                                                {{ option.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>Min Executed Things</label>
                                    <input type="number" class="form-control" placeholder="100"
                                        [(ngModel)]="jobData.abort_config!.configurations[0].minExecutedThings" />
                                </div>

                                <div class="form-group">
                                    <label>Threshold Percentage</label>
                                    <input type="number" class="form-control" placeholder="20"
                                        [(ngModel)]="jobData.abort_config!.configurations[0].thresholdPercentage" />
                                </div>
                            </div>

                            <h3>Abort Configuration 2</h3>
                            <div class="form-row">
                                <div class="form-group">
                                    <label>Action</label>
                                    <input type="text" class="form-control" placeholder="CANCEL"
                                        [(ngModel)]="jobData.abort_config!.configurations[1].action" />
                                </div>

                                <div class="form-group">
                                    <label>Failure Type</label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-select
                                            [(ngModel)]="jobData.abort_config!.configurations[1].failureType"
                                            (ngModelChange)="onFailureTypeChange(1)"
                                            panelClass="mat-mdc-select-panel-custom"
                                            name="abortFailureType2">
                                            <mat-option *ngFor="let option of getFailureTypeOptions(1)" [value]="option.value">
                                                {{ option.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label>Min Executed Things</label>
                                    <input type="number" class="form-control" placeholder="100"
                                        [(ngModel)]="jobData.abort_config!.configurations[1].minExecutedThings" />
                                </div>

                                <div class="form-group">
                                    <label>Threshold Percentage</label>
                                    <input type="number" class="form-control" placeholder="20"
                                        [(ngModel)]="jobData.abort_config!.configurations[1].thresholdPercentage" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Right Column: Preview -->
                    <div class="preview-column">
                        <div class="preview-header">Preview</div>
                        <div class="preview-section">

                            <h3>Job Executions Rollout Configurtion</h3>
                            <div class="preview-item-row">
                                <div class="preview-item">
                                    <span class="preview-label">Base Rate Per Minute</span>
                                    <span class="preview-value">{{
                                        jobData.job_executions_rollout_config?.baseRatePerMinute }}</span>
                                </div>

                                <div class="preview-item">
                                    <span class="preview-label">Increment Factor</span>
                                    <span class="preview-value">{{
                                        jobData.job_executions_rollout_config?.incrementFactor }}</span>
                                </div>
                            </div>

                            <div class="preview-item-row">
                                <div class="preview-item">
                                    <span class="preview-label">Number of Succeeded Things</span>
                                    <span class="preview-value">{{
                                        jobData.job_executions_rollout_config?.numberOfSucceededThings }}</span>
                                </div>

                                <div class="preview-item">
                                    <span class="preview-label">Maximum Per Minute</span>
                                    <span class="preview-value">{{
                                        jobData.job_executions_rollout_config?.maximumPerMinute }}</span>
                                </div>
                            </div>

                            <h3>Abort Configuration 1</h3>
                            <div class="preview-item-row">
                                <div class="preview-item">
                                    <span class="preview-label">Action</span>
                                    <span class="preview-value">{{ jobData.abort_config!.configurations[0].action
                                        }}</span>
                                </div>

                                <div class="preview-item">
                                    <span class="preview-label">Failure Type</span>
                                    <span class="preview-value">{{
                                        jobData.abort_config!.configurations[0].failureType }}</span>
                                </div>
                            </div>

                            <div class="preview-item-row">
                                <div class="preview-item">
                                    <span class="preview-label">Min Executed Things</span>
                                    <span class="preview-value">{{
                                        jobData.abort_config!.configurations[0].minExecutedThings }}</span>
                                </div>

                                <div class="preview-item">
                                    <span class="preview-label">Threshold Percentage</span>
                                    <span class="preview-value">{{
                                        jobData.abort_config!.configurations[0].thresholdPercentage }}</span>
                                </div>
                            </div>

                            <h3>Abort Configuration 2</h3>
                            <div class="preview-item-row">
                                <div class="preview-item">
                                    <span class="preview-label">Action</span>
                                    <span class="preview-value">{{ jobData.abort_config!.configurations[1].action
                                        }}</span>
                                </div>

                                <div class="preview-item">
                                    <span class="preview-label">Failure Type</span>
                                    <span class="preview-value">{{
                                        jobData.abort_config!.configurations[1].failureType }}</span>
                                </div>
                            </div>

                            <div class="preview-item-row">
                                <div class="preview-item">
                                    <span class="preview-label">Min Executed Things</span>
                                    <span class="preview-value">{{
                                        jobData.abort_config!.configurations[1].minExecutedThings }}</span>
                                </div>

                                <div class="preview-item">
                                    <span class="preview-label">Threshold Percentage</span>
                                    <span class="preview-value">{{
                                        jobData.abort_config!.configurations[1].thresholdPercentage }}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Step 5: Review and Finish -->
                <div *ngIf="currentStep === 5" class="form-container review-container">
                    <div class="review-column">
                        <!-- Basic Details Section -->
                        <div class="review-section">
                            <button class="review-header" (click)="toggleSection('basicDetails')">
                                <span>1. Basic Details</span>
                                <mat-icon [class.rotated]="expandedSections.basicDetails">arrow_drop_down</mat-icon>
                            </button>
                            <div class="review-content" *ngIf="expandedSections.basicDetails">
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Job Name</span>
                                        <span class="review-value">{{ jobData.job_name }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Actual Model</span>
                                        <span class="review-value">{{ getDropdownLabel(jobData.actual_model, actualModels)
                                            }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Model</span>
                                        <span class="review-value">{{ getDropdownLabel(jobData.model, models)
                                            }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Wi-Fi Board Firmware Section -->
                        <div class="review-section">
                            <button class="review-header" (click)="toggleSection('wifiBoard')">
                                <span>2. Wi-Fi Board Firmware</span>
                                <mat-icon [class.rotated]="expandedSections.wifiBoard">arrow_drop_down</mat-icon>
                            </button>
                            <div class="review-content" *ngIf="expandedSections.wifiBoard">
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Firmware Version</span>
                                        <span class="review-value">{{ jobData.wifi_firmware_version || ''
                                            }}</span>
                                    </div>
                                </div>

                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Firmware Path on Device</span>
                                        <span class="review-value">{{ jobData.wifi_firmware_path_on_device || ''
                                            }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Priority</span>
                                        <span class="review-value">{{ jobData.wifi_firmware_priority || ''
                                            }}</span>
                                    </div>
                                </div>

                                <div class="review-item">
                                    <span class="review-label">Description</span>
                                    <span class="review-value">{{ jobData.wifi_firmware_description || ''
                                        }}</span>
                                </div>

                            </div>
                        </div>

                        <!-- Main Board Firmware Section -->
                        <div class="review-section" *ngIf="!isMainBoardFirmwareDisabled">
                            <button class="review-header" (click)="toggleSection('mainBoard')">
                                <span>3. Main Board Firmware</span>
                                <mat-icon [class.rotated]="expandedSections.mainBoard">arrow_drop_down</mat-icon>
                            </button>
                            <div class="review-content" *ngIf="expandedSections.mainBoard">
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Firmware Version</span>
                                        <span class="review-value">{{ jobData.main_firmware_version || ''
                                            }}</span>
                                    </div>
                                </div>

                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Firmware Path on Device</span>
                                        <span class="review-value">{{ jobData.main_firmware_path_on_device || ''
                                            }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Priority</span>
                                        <span class="review-value">{{ jobData.main_firmware_priority || ''
                                            }}</span>
                                    </div>
                                </div>

                                <div class="review-item">
                                    <span class="review-label">Description</span>
                                    <span class="review-value">{{ jobData.main_firmware_description || ''
                                        }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurations Section -->
                        <div class="review-section">
                            <button class="review-header" (click)="toggleSection('configurations')">
                                <span>{{ isMainBoardFirmwareDisabled ? '3. Configurations' : '4. Configurations' }}</span>
                                <mat-icon [class.rotated]="expandedSections.configurations">arrow_drop_down</mat-icon>
                            </button>
                            <div class="review-content" *ngIf="expandedSections.configurations">
                                <h3>Job Executions Rollout Configuration</h3>
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Base Rate Per Minute</span>
                                        <span class="review-value">{{
                                            jobData.job_executions_rollout_config?.baseRatePerMinute }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Increment Factor</span>
                                        <span class="review-value">{{
                                            jobData.job_executions_rollout_config?.incrementFactor }}</span>
                                    </div>
                                </div>
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Number of Succeeded Things</span>
                                        <span class="review-value">{{
                                            jobData.job_executions_rollout_config?.numberOfSucceededThings }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Maximum Per Minute</span>
                                        <span class="review-value">{{
                                            jobData.job_executions_rollout_config?.maximumPerMinute }}</span>
                                    </div>
                                </div>
                                <h3>Abort Configuration 1</h3>
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Action</span>
                                        <span class="review-value">{{ jobData.abort_config!.configurations[0].action
                                            }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Failure Type</span>
                                        <span class="review-value">{{
                                            jobData.abort_config!.configurations[0].failureType }}</span>
                                    </div>
                                </div>
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Min Executed Things</span>
                                        <span class="review-value">{{
                                            jobData.abort_config!.configurations[0].minExecutedThings }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Threshold Percentage</span>
                                        <span class="review-value">{{
                                            jobData.abort_config!.configurations[0].thresholdPercentage }}</span>
                                    </div>
                                </div>
                                <h3>Abort Configuration 2</h3>
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Action</span>
                                        <span class="review-value">{{ jobData.abort_config!.configurations[1].action
                                            }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Failure Type</span>
                                        <span class="review-value">{{
                                            jobData.abort_config!.configurations[1].failureType }}</span>
                                    </div>
                                </div>
                                <div class="review-row">
                                    <div class="review-item">
                                        <span class="review-label">Min Executed Things</span>
                                        <span class="review-value">{{
                                            jobData.abort_config!.configurations[1].minExecutedThings }}</span>
                                    </div>
                                    <div class="review-item">
                                        <span class="review-label">Threshold Percentage</span>
                                        <span class="review-value">{{
                                            jobData.abort_config!.configurations[1].thresholdPercentage }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Form Actions -->
            <div class="form-actions">
                <button *ngIf="currentStep === 1" class="btn btn-outline" (click)="cancelCreation()">
                    Cancel
                </button>

                <button *ngIf="currentStep > 1" class="btn btn-secondary" (click)="previousStep()">
                    Back
                </button>

                <button *ngIf="currentStep !== 5" class="btn btn-reset" (click)="resetCurrentStep()">
                    Reset
                </button>

                <button class="btn btn-primary" (click)="nextStep()" [disabled]="!isCurrentStepValid() || isLoading">
                    {{ currentStep === totalSteps ? (isLoading ? 'Creating...' : 'Create Job') : 'Next' }}
                </button>
            </div>
        </ng-container>
    </div>
</div>